export function SortEntries() {
    return [
        50,
        100,
        200
    ];
}
